import { UserAdministrationInfo } from '../common/interfaces/common.interface';
import api from './api';

export const getUserAdministrationInfo = async (): Promise<UserAdministrationInfo> => {
  const response = await api.get(`/user/administration-info`);

  return response.data.results;
};
